import request from "../Requests/requests";
import { editTag } from "../store/tagsReducer";

export const editTags = (payload) => {
    return async dispatch => {
        try {
            const response =  await request.put('/Tag/Update', {
                tagId: payload.id,
                tagName: payload.tagName
            })
            dispatch(editTag(payload))
            const data = response.data
            return data
        } catch (error) {
            return error
        }
    }
}